import { ScrollerAlign, ScrollerPurpose } from "../../options";

export function getMaxIndex(itemCount: number, canvasCount: number, align: ScrollerAlign, purpose: ScrollerPurpose) {
    let maxIndex = itemCount === 0 ? 0 : itemCount - 1;
    if (align === ScrollerAlign.Left && purpose == ScrollerPurpose.Scroll) maxIndex = maxIndex - canvasCount + 2;
    if (maxIndex < 0) maxIndex = 0;
    return maxIndex;
}
